// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__fIHO2","links":"Footer_links__A3EHp","privacy_policy":"Footer_privacy_policy__2-tYs","subscribe":"Footer_subscribe__1_tg8","input":"Footer_input__2Z-tz"};